import { SelectBox } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import type { SortTypeOption } from '@eti/schema-types';

const selectBoxStyles = css`
  flex: 0;
  padding: 16px 16px 0;
`;

type Option = {
  label: string;
  value: string;
};

const getOptions = (sortTypes: SortTypeOption[]): Option[] =>
  sortTypes.map((sortType) => ({
    value: sortType.code,
    label: sortType.name,
  }));

interface SortTypesProps {
  availableSortTypes: SortTypeOption[];
  onSort: (value: string) => void;
  selectedSortType: string;
}

const SortTypes = ({ availableSortTypes = [], onSort, selectedSortType }: SortTypesProps) => {
  const { t } = useTranslation();
  const options = getOptions(availableSortTypes);
  const selectedValue = options.find((option) => option.value === selectedSortType) ?? null;

  const handleSelect = (option: Option) => {
    onSort(option.value);
  };

  return (
    <SelectBox
      className={selectBoxStyles}
      data-testid="resultPage-debugFilters-sortTrips-dropdown"
      label={t('Result.SortTripsBy.Label')}
      name="debugFilters-sortTrips"
      onChange={handleSelect}
      options={options}
      value={selectedValue}
    />
  );
};

export default SortTypes;
